import { get } from "lodash";
import { useQuery } from "react-query";

import { ILicenseRequestApi } from "~/entity/Licenses/model/schema";

import { useLicenseRequests } from "./useLicenseRequests";

export const useGetLicenseRequestById = (id?: string) => {
  const { queryKeys, getLicenseRequestById } = useLicenseRequests();

  const query = useQuery({
    queryKey: queryKeys.byId(id),
    queryFn: () => getLicenseRequestById(String(id)),
    enabled: Boolean(id),
  });

  const request = get(query.data, "data.request") as
    | ILicenseRequestApi
    | undefined;

  return {
    ...query,
    request,
  };
};
